import React from "react";

import { Container, Content, Card, StyledEmpresa } from "./styles";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useState } from "react";

import { api } from "../../../services/api";
import { mascaraCnpj } from "../../../services/utils";
import SideBarAdmin from "../../../components/SideBarAdmin";
import Confirm from "../../../components/Confirm";
import Alerts from "../../../components/Alerts";

const Empresa = ({ empresa, ativar, desativar }) => {
  return (
    <StyledEmpresa>
      <section>
        <h3>{empresa.nome}</h3>
        <p>
          <strong>CNPJ: </strong>
          {mascaraCnpj(empresa.cnpj)}
        </p>
        <p>
          <strong>Contato: </strong>
          {empresa.nome_contato}
        </p>
        <p>
          <strong>E-mail: </strong>
          {empresa.email_contato}
        </p>
        <p>
          <strong>Telefone: </strong>
          {empresa.telefone_contato}
        </p>
      </section>
      {empresa.status !== 1 ? (
        <span onClick={ativar}>
          <p style={{ color: "green" }}>Ativar</p>
        </span>
      ) : (
        <span onClick={desativar}>
          <p style={{ color: "red" }}>Desativar</p>
        </span>
      )}
    </StyledEmpresa>
  );
};

function Home() {
  const headerLinks = [{ label: "Sair", to: "/" }];

  const [empresas, setEmpresas] = useState({
    novas: [],
    ativas: [],
    inativas: [],
  });

  const [confirm, setConfirm] = useState(undefined);
  const [mensagem, setMensagem] = useState(undefined);
  const [empresaIdDesativar, setEmpresaIdDesativar] = useState(undefined);

  useEffect(() => {
    const listarEmpresas = async () => {
      try {
        const retorno = await api.get("/empresas");

        setEmpresas(retorno.data);
      } catch (e) {
        console.log(e);
      }
    };

    listarEmpresas();
  }, []);

  const ativar = (empresaId) => {
    try {
      api.post(`/empresas/${empresaId}/ativacao`);

      const [empresaAux] = empresas.inativas.filter((v) => v.id === empresaId);

      empresaAux.status = 1;

      setEmpresas({
        ...empresas,
        inativas: empresas.inativas.filter((v) => v.id !== empresaId),
        ativas: [empresaAux, ...empresas.ativas],
      });

      setMensagem({
        show: true,
        titulo: "Ok",
        detalhe: "Empresa ativada.",
        tipo: "sucesso",
      });
    } catch (e) {
      console.log(e);
    }
  };

  const desativar = () => {
    try {
      api.delete(`/empresas/${empresaIdDesativar}/ativacao`);

      const [empresaAux] = empresas.ativas.filter(
        (v) => v.id === empresaIdDesativar
      );

      empresaAux.status = 2;

      setEmpresas({
        ...empresas,
        ativas: empresas.ativas.filter((v) => v.id !== empresaIdDesativar),
        inativas: [empresaAux, ...empresas.inativas],
      });

      setConfirm(undefined);

      setMensagem({
        show: true,
        titulo: "Ok",
        detalhe: "Empresa desativada.",
        tipo: "sucesso",
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Container>
      <Confirm
        mensagem={confirm}
        setMensagem={setConfirm}
        handleConfirm={desativar}
      />
      <Alerts
        mensagem={mensagem}
        setMensagem={setMensagem}
        tipo={mensagem?.tipo}
      />
      <SideBarAdmin></SideBarAdmin>
      <Header links={headerLinks} theme="black" />

      <Content>
        <Card>
          <h1>Novas Empresas</h1>
          {empresas.novas.length === 0
            ? "Nenhuma nova empresa cadastrada."
            : empresas.novas.map((e) => (
                <Empresa
                  key={e.id}
                  ativar={() => ativar(e.id)}
                  desativar={() => desativar(e.id)}
                  empresa={e}
                />
              ))}
        </Card>

        <Card style={{ marginBottom: 0 }}>
          <h1>Empresas Cadastradas</h1>
          {empresas.ativas.map((e) => (
            <Empresa
              key={e.id}
              ativar={() => ativar(e.id)}
              desativar={() => {
                setEmpresaIdDesativar(e.id);
                setConfirm({
                  show: true,
                  titulo: "Desativar a empresa?",
                  detalhe: "Todas as vagas dela serão encerradas.",
                });
              }}
              empresa={e}
            />
          ))}
        </Card>
        <Card style={{ marginBottom: 0 }}>
          <h1>Empresas inativas</h1>
          {empresas.inativas.map((e) => (
            <Empresa
              key={e.id}
              ativar={() => ativar(e.id)}
              desativar={() => {
                setEmpresaIdDesativar(e.id);
                setConfirm({
                  show: true,
                  titulo: "Deseja realmente desativar a empresa?",
                  detalhe: "Todas as vagas dela serão encerradas.",
                });
              }}
              empresa={e}
            />
          ))}
        </Card>
      </Content>
    </Container>
  );
}

export default Home;
